
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34 31"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.452 4.983l2.319 2.324a1.545 1.545 0 002.195 0 1.55 1.55 0 00.2-1.875h5.659a1.544 1.544 0 001.545-1.55 1.551 1.551 0 00-1.546-1.549h-5.657a1.552 1.552 0 00-.201-1.875 1.546 1.546 0 00-2.195 0l-2.319 2.325a1.55 1.55 0 00-.325.511c-.154.377-.154.8 0 1.178.074.19.184.364.325.511zm16.432 6.059a1.548 1.548 0 00-.325-.512l-2.318-2.324a1.546 1.546 0 00-2.195 0 1.551 1.551 0 00-.201 1.875h-5.658a1.544 1.544 0 00-1.546 1.55 1.551 1.551 0 001.546 1.55h5.658a1.553 1.553 0 00.2 1.874 1.545 1.545 0 002.196 0l2.318-2.324c.141-.148.252-.321.325-.512.155-.377.155-.8 0-1.177zm-18.426 1.363a6.173 6.173 0 00-3.435 1.045 6.195 6.195 0 00-2.277 2.782 6.212 6.212 0 001.34 6.754 6.179 6.179 0 006.738 1.344 6.186 6.186 0 002.775-2.283 6.209 6.209 0 00-.769-7.826 6.175 6.175 0 00-4.372-1.816zm0 9.298a3.087 3.087 0 01-2.856-1.913 3.107 3.107 0 01.67-3.378 3.09 3.09 0 015.278 2.192c0 .822-.326 1.61-.906 2.191a3.088 3.088 0 01-2.186.908zm13.912-4.649a1.544 1.544 0 00-1.546 1.55v7.747a1.551 1.551 0 01-1.545 1.55H4.637a1.544 1.544 0 01-1.545-1.55V13.955a1.552 1.552 0 011.545-1.55H7.73a1.544 1.544 0 001.546-1.069l.835-2.51a1.549 1.549 0 011.39-1.07h2.412a1.544 1.544 0 001.546-1.549 1.551 1.551 0 00-1.546-1.55h-2.411a4.63 4.63 0 00-2.718.882 4.648 4.648 0 00-1.688 2.31l-.479 1.457H4.637c-1.23 0-2.409.49-3.279 1.362A4.654 4.654 0 000 13.955V26.35c0 1.233.489 2.416 1.358 3.287A4.632 4.632 0 004.638 31h21.64c1.23 0 2.41-.49 3.28-1.362a4.654 4.654 0 001.358-3.287v-7.747a1.551 1.551 0 00-1.546-1.55z"}})])
          )
        }
      }
    